import { action } from 'typesafe-actions';
import { AnnouncementActionTypes } from 'types';

export const getListAnnouncementsStart = (payload: any) =>
  action(AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_START, payload);

export const getListAnnouncementsSuccess = (payload: any) =>
  action(AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_SUCCESS, payload);

export const getListAnnouncementsFailure = (payload: string) =>
  action(AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_FAILURE, payload);
